import React from "react";
export const C = {
  ink: "#15130b",
  inkSoft: "#3a3626",
  cream: "#f8f1df",
  white: "#fffdf6",
  tomato: "#e8573a",
  tomatoDark: "#c4442b",
  sun: "#ffd447",
  sunLight: "#ffe27a",
  sunDeep: "#f2c12e",
  green: "#0a8a3f",
  greenDark: "#076b30"
};
interface DiscProps {
  cx: number;
  /** y of the top ellipse's centre */
  y: number;
  rx: number;
  ry: number;
  h: number;
  top: string;
  side: string;
  sideDecor?: React.ReactNode;
  topDecor?: React.ReactNode;
}

/** A flat-shaded cylinder seen from slightly above — the building block for every part. */
export function Disc({
  cx,
  y,
  rx,
  ry,
  h,
  top,
  side,
  sideDecor,
  topDecor
}: DiscProps) {
  const sidePath = `M ${cx - rx} ${y} L ${cx - rx} ${y + h} A ${rx} ${ry} 0 0 0 ${cx + rx} ${y + h} L ${cx + rx} ${y} Z`;
  return <g stroke={C.ink} strokeWidth={2.5} strokeLinejoin="round" data-id="element-371" data-mp="2qo008xo949ig">
      <path d={sidePath} fill={side} data-id="element-372" data-mp="2ql449evyruwn" />
      {sideDecor}
      <ellipse cx={cx} cy={y} rx={rx} ry={ry} fill={top} data-id="element-373" data-mp="2lpey2spfvfrd" />
      {topDecor}
    </g>;
}
export function Shadow({
  cx,
  cy,
  rx
}: {
  cx: number;
  cy: number;
  rx: number;
}) {
  return <ellipse cx={cx} cy={cy} rx={rx} ry={rx * 0.14} fill={C.ink} opacity={0.12} data-id="element-374" data-mp="27kpromy898iq" />;
}